var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"language-switcher"},[_c('span',{on:{"click":function($event){return _vm.$_changeLanguage()}}},[_vm._v(_vm._s(_vm.oppositeLanguage))])])}
var staticRenderFns = []

export { render, staticRenderFns }